import { DataGridColSettings } from '@/components/DataGrid/utils';

export const propertyEvidenceDataGridCols: DataGridColSettings[] = [
  {
    field: 'number',
    headerName: 'Property ID',
    width: 120,
    visible: true,
  },
  {
    field: 'kase',
    headerName: 'Related case',
    width: 120,
    visible: true,
  },
  {
    field: 'name',
    headerName: 'Name',
    width: 140,
    visible: true,
  },
  {
    field: 'typeTag',
    headerName: 'Property type tag',
    width: 120,
    visible: true,
  },
  {
    field: 'itemNumber',
    headerName: 'Item number',
    width: 120,
    visible: true,
  },
  {
    field: 'type',
    headerName: 'Type',
    width: 140,
    visible: true,
  },
  {
    field: 'involvement',
    headerName: 'Involvement',
    width: 120,
    visible: true,
  },
  {
    field: 'dateLogged',
    headerName: 'Date logged',
    width: 120,
    visible: true,
  },
  {
    field: 'loggedBy',
    headerName: 'Collected by',
    width: 140,
    visible: true,
  },
  {
    field: 'agency',
    headerName: 'Agency name',
    width: 120,
    visible: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 120,
    visible: true,
  },
  {
    field: 'loggedAddress',
    headerName: 'Inventory Location',
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 90,
    visible: true,
  },
];
